<app-card-table
    #table
    [tableTitle]="'service.settings.general.visitType.label'"
    [columns]="columns"
    translatePrefix="service.settings.general.visitType."
    [hideCheckboxes]="true"
    [additionalFilter]="[[{ column: 'serviceId', operator: 'EQ', value: [routeParams.serviceId()] }]]"
    [gridData]="store.data.getServiceVisitTypes()"
    [refreshCallbackFragment]="visitTypeQuery"
    [refreshCallback]="store.api.getServiceVisitTypes"
    [defaultSorters]="[{ column: 'createdAt', direction: 'DESC' }]"
    (deleteCallbackWithEvent)="delete($event)"
    (createCallback)="update()"
    (detailCallback)="update($event)"
    [showDelete]="isAllowed['service.update']()"
    [showDetail]="isAllowed['service.update']()"
>
</app-card-table>
